var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOvulationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 13.5832C7.66667 13.5832 9.16667 12.0582 9.16667 10.2082C9.16667 9.2415 8.69167 8.32484 7.74167 7.54984C6.79167 6.77484 6.075 5.62484 5.83333 4.4165C5.59167 5.62484 4.88333 6.78317 3.925 7.54984C2.96667 8.3165 2.5 9.24984 2.5 10.2082C2.5 12.0582 4 13.5832 5.83333 13.5832Z",
    stroke: "#FFC35C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4669 5.49993C11.04 4.58421 11.4463 3.57414 11.6669 2.5166C12.0835 4.59993 13.3335 6.59994 15.0002 7.93327C16.6669 9.2666 17.5002 10.8499 17.5002 12.5166C17.505 13.6685 17.1676 14.7959 16.5309 15.7558C15.8941 16.7158 14.9867 17.4651 13.9236 17.9087C12.8606 18.3523 11.6897 18.4703 10.5595 18.2477C9.4293 18.0251 8.39064 17.4719 7.5752 16.6583",
    stroke: "#FFC35C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvulationIcon);
export default __webpack_public_path__ + "static/media/ovulation_icon.8796ba160bc7767d00dcd272b85fef1c.svg";
export { ForwardRef as ReactComponent };